export const apolloConfig = {
  uri: process.env.REACT_APP_APOLLO_URI,
};
